var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 50 50",
    width: "50pt",
    height: "50pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_1m6NC2FOpsjqjx4n2dEe8xWfaeyRXc6P"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_1m6NC2FOpsjqjx4n2dEe8xWfaeyRXc6P)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 45 5 L 5 5 C 2.25 5 0.025 7.25 0.025 10 L 0 40 C 0 42.75 2.25 45 5 45 L 45 45 C 47.75 45 50 42.75 50 40 L 50 10 C 50 7.25 47.75 5 45 5 Z  M 45 15 L 25 27.5 L 5 15 L 5 10 L 25 22.5 L 45 10 L 45 15 Z ",
    fill: "rgb(255,255,255)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/IconMail.55471ee3df138b005bdb628b2f75cdd4.svg";
export { ForwardRef as ReactComponent };